import { render, staticRenderFns } from "./basic.md?vue&type=template&id=5993c2e8&"
import script from "./basic.md?vue&type=script&lang=js&"
export * from "./basic.md?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/core/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5993c2e8')) {
      api.createRecord('5993c2e8', component.options)
    } else {
      api.reload('5993c2e8', component.options)
    }
    module.hot.accept("./basic.md?vue&type=template&id=5993c2e8&", function () {
      api.rerender('5993c2e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "website/views/plugin/legend/basic.md"
export default component.exports